import React from "react";
import { Entity } from "@common/types/entity";
import { PickerEntityItem } from "@components/entity/PickerEntityItem";

interface Props {
    entity: Entity;
}

/** A business entity row of the transaction entity picker; the root draws the selected check. */
export const TransactionEntityMenuItem: React.FC<Props> = ({ entity }) => (
    <PickerEntityItem value={entity.id} entity={entity} />
);
